module.exports = __webpack_public_path__ + "static/media/PrinterPrints.6ee3dec0.mp3";